import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Spinner from '@components/spinner'
import Error from '@components/Error/NoContent'
import Pagination from '@components/Pagination'
import Header from '@components/Details/Header'
import Badge from '@components/Details/Badge'
import { formatNumber } from '@atheneum/api/dist/lib'
import EntriesTable from './ResultsTable'
import Actions from './Actions'
import Scroll from '@components/Scroll'

class Results extends Component {
  static propTypes = {
    financialRevenueStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.loadInitialData()
  }

  loadInitialData () {
    this.props.financialRevenueStore.filter()
    this.props.financialRevenueStore.getToInvoiceAmount()
  }

  renderError (error) {
    if (error) return <Error />
  }

  renderLoader () {
    return <Spinner />
  }

  render () {
    const {
      loading,
      error,
      entries,
      query,
      count,
      filter,
      toInvoiceAmount
    } = this.props.financialRevenueStore
    if (error) {
      return this.renderError(error)
    }
    if (loading) {
      return this.renderLoader()
    }

    return (
      <div className='revenues-view'>
        <Scroll>
          <div className='project-wrapper'>
            <Header>
              <div className='info info--noLeft'>
                <div className='name-status-wrapper'>
                  <h1>Financial revenue</h1>
                </div>
              </div>
              <Badge
                label='To invoice'
                value={`${formatNumber(toInvoiceAmount)} EUR`}
              />
            </Header>
            <div className='invoice-wrapper animate-intro'>
              {entries.length > 0 ? (
                <div>
                  <div className='actions-wrapper clearfix'>
                    <Actions />
                  </div>
                  <EntriesTable entries={entries} />
                  <Pagination
                    total={count}
                    perPage={query.limit}
                    page={query.page}
                    onChange={p => {
                      query.page = p
                      filter()
                    }}
                  />
                </div>
              ) : (
                <Error
                  label={'No results match the current filter parameters'}
                />
              )}
            </div>
          </div>
        </Scroll>
      </div>
    )
  }
}

export default inject('financialRevenueStore')(observer(Results))
